import axiosInstance from './axiosInstance';
const API_URL = process.env.REACT_APP_API_URL;

export const getPlantRateGlobals = async () => (await axiosInstance.get(`${API_URL}/plant-rate-globals`)).data;
export const getPlantRateGlobalsById = async (id) => (await axiosInstance.get(`${API_URL}/plant-rate-globals/${id}`)).data;
export const createPlantRateGlobals = async (payload) => (await axiosInstance.post(`${API_URL}/plant-rate-globals`, payload)).data;
export const updatePlantRateGlobals = async (id, payload) => (await axiosInstance.put(`${API_URL}/plant-rate-globals/${id}`, payload)).data;
export const deletePlantRateGlobals = async (id) => (await axiosInstance.delete(`${API_URL}/plant-rate-globals/${id}`)).data;
